<template>
  <div>
    <div>
      <h2>Test random players</h2>

      <p class="mb-2">
        For feature testing purposes, you can ask server to return random players.
      </p>

      <p class="alert alert-warning">
        NOTE: This feature only available when property IS_DEV is enabled.
      </p>

      <form @submit.prevent="loadRandomPlayers" class="mb-2">
        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="amount">Players to request</label>
          <div class="col-md-8">
            <input v-model.number="amount" id="amount" class="form-control" type="number" min="0">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="exclude">Exclude id</label>
          <div class="col-md-8">
            <input v-model="exclude" id="exclude" class="form-control">
          </div>
        </div>

        <hr>

        <b-button class="offset-md-4" type="submit" variant="primary">Request</b-button>
      </form>

      <div v-if="isLoadedNormal" class="mb-2">
        <p>
          Players ({{ randomPlayers.length }}):
          <span v-for="(playerId, index) in randomPlayers"
                :key="playerId">
            <b-link :to="{name: 'player_info', params: { playerId: playerId }}">{{ playerId }}</b-link>{{ index === randomPlayers.length - 1 ? '.' : ',' }}
          </span>
        </p>
      </div>

      <loading-indicator v-if="isLoading"/>
    </div>
  </div>
</template>

<script>
import notifier from '../../notifier';
import {HTTP} from '../../http-common';

import LoadingIndicator from '../LoadingIndicator.vue';

const LOAD_STATE_INIT = 1;
const LOAD_STATE_LOADING = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR = 4;

export default {
  name: "DevTestRandomPlayers",

  components: {
    LoadingIndicator,
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      amount: 100,
      exclude: "100",

      randomPlayers: null,
    }
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },
  },

  methods: {
    loadRandomPlayers() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const data = new FormData();
      data.set('amount', this.amount);
      data.set('exclude', this.exclude);

      HTTP.post('/river_rumble/test_random_players', data)
          .then(response => {
            const data = response.data.data;
            if (data === null) {
              notifier.showError('Invalid server response. data === null.', {sender: this});
              return;
            }

            this.randomPlayers = data.random_players || [];

            this.loadState = LOAD_STATE_LOADED_NORMAL;
          })
          .catch(e => {
            this.loadState = LOAD_STATE_LOADED_ERROR;
            notifier.showError(e, {sender: this});
          });
    },
  }
}
</script>
